(function () {
  'use strict';
  function redirectAfterSuccessfulContact() {
    if (!document.querySelector('[data-ss-contact-success]')) return;
    if (window.location.pathname.replace(/\/$/, '') === '/pages/gracias') return;
    window.location.replace('/pages/gracias');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirectAfterSuccessfulContact, { once: true });
  } else {
    redirectAfterSuccessfulContact();
  }
}());
